module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/自动点胶机.d57210f6.jpg";